import React from "react";
import { Flex, type FlexProps } from "@chakra-ui/react";

export function FilterButton({ children, ...props }: FlexProps) {
  return (
    <Flex
      align="center"
      bg="product.teal.300"
      borderRadius="6px"
      gap="tinier"
      lineHeight="none"
      textStyle="caption2"
      fontWeight="semibold"
      py="tiny"
      px="tiny"
      {...props}
    >
      {children}
    </Flex>
  );
}
